// --- START OF FILE frontend/src/components/ProjectDetail/panels/JournalTaskCard.js ---
import React, { useState, useEffect } from 'react';
import { CheckSquare, Square } from 'lucide-react';
import { apiService } from '../../../services/api'; // S'assurer que le chemin est correct

const JournalTaskCard = ({ task }) => {
    const [currentTask, setCurrentTask] = useState(task);

    useEffect(() => {
        if (task?.id && typeof task.id === 'number') {
            apiService.get(`/tasks/${task.id}`)
              .then(freshTask => {
                // On fusionne les nouvelles données avec celles qu'on a déjà,
                // pour conserver owner_name et owner_email qui ne sont pas dans l'API GET /tasks/{id}
                setCurrentTask(prev => ({ ...prev, ...freshTask }));
              })
              .catch(err => {
                console.error(`Impossible de rafraîchir la tâche ${task.id}`, err);
              });
        }
    }, [task?.id]);

    if (!currentTask) return null;

    // --- MODIFICATION ICI : Logique pour les initiales basée sur l'email ---
    const getOwnerInitials = (task) => {
        // Priorité à l'email pour générer les initiales (ex: remy.cartier -> RC)
        if (task?.owner_email) {
            const emailName = task.owner_email.split('@')[0];
            const nameParts = emailName.split('.').filter(Boolean); // Sépare par le point et retire les parties vides
            return nameParts.map(part => part[0]?.toUpperCase() || '').join('');
        }
        // Fallback sur le nom si l'email n'est pas disponible (ancienne données)
        if (task?.owner_name) {
            const nameParts = task.owner_name.trim().split(' ').filter(Boolean);
            return nameParts.map(part => part[0]?.toUpperCase() || '').join('');
        }
        return '?';
    };

    const ownerInitials = getOwnerInitials(currentTask);
    // --- FIN DE LA MODIFICATION ---

    return (
        <span
            className={`inline-flex items-center space-x-2 border rounded-md px-2 py-1 text-sm mx-1 ${
                currentTask.is_completed ? 'bg-green-50 border-green-200' : 'bg-blue-50 border-blue-200'
            }`}
            contentEditable={false} 
            data-task-id={currentTask.id}
        >
            {currentTask.is_completed ? 
                <CheckSquare size={14} className="text-green-600 flex-shrink-0" /> :
                <Square size={14} className="text-blue-600 flex-shrink-0" />
            }
            <span className={`font-medium ${
                currentTask.is_completed ? 'text-green-800 line-through' : 'text-blue-800'
            }`}>
                {currentTask.name}
            </span>
            <span
                className={`flex items-center justify-center w-5 h-5 rounded-full text-xs font-bold ${
                    currentTask.is_completed ? 'bg-green-200 text-green-700' : 'bg-blue-200 text-blue-700'
                }`}
                title={`Assigné à ${currentTask.owner_name || 'non défini'}`}
            >
                {ownerInitials} {/* Utilise la nouvelle fonction */}
            </span>
        </span>
    );
};

export default JournalTaskCard;
// --- END OF FILE frontend/src/components/ProjectDetail/panels/JournalTaskCard.js ---